export * from './pm-statusnum2statusname.directive';
export * from './pm-statusnum2statusname.module';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/pm-statusnum2statusname/index.ts